export const siteInfo = {
  name: '51吃瓜网入口',
  slogan: '全网黑料爆料 · 吃瓜群众第一站',
  subSlogan: '实时追踪娱乐圈风云，一手掌握最新猛料',
};

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '吃瓜现场', href: '#media' },
  { label: '热度榜单', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '吃瓜精选', href: '#cards' },
  { label: '投稿爆料', href: '#contact' },
  { label: '常见问题', href: '#faq' },
];

export const heroData = {
  tag: '🔥 今日热搜 · 实时追踪',
  stats: [
    { label: '24小时更新', value: '全天候' },
    { label: '覆盖领域', value: '12大板块' },
    { label: '瓜友社区', value: '百万活跃' },
  ],
  intro: '51吃瓜网入口是全网领先的娱乐圈黑料爆料聚合平台，覆盖明星八卦、影视内幕、综艺翻车、直播争议等热门领域。我们坚持7×24小时全天候追踪最新动态，汇聚全网吃瓜资源，让每一位瓜友都能第一时间掌握最劲爆的娱乐圈内幕消息。从热门综艺录制现场的意外花絮，到明星私生活的独家揭秘，51吃瓜网入口始终站在吃瓜第一线，为广大网友提供最全、最快、最真实的黑料爆料内容。',
  ctaPrimary: '立即吃瓜',
  ctaSecondary: '投稿爆料',
  heroImage: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20juicy%20watermelon%20sliced%20open%20with%20dramatic%20red%20interior%2C%20surrounded%20by%20floating%20newspaper%20clippings%20and%20camera%20lens%20elements%2C%20warm%20orange%20and%20deep%20red%20color%20palette%2C%20modern%20editorial%20illustration%20style%2C%20bold%20graphic%20composition%2C%20clean%20background%20with%20subtle%20grain%20texture&width=600&height=500&seq=hero-gossip-main&orientation=landscape',
};

export const mediaData = [
  {
    title: '某顶流男星疑似深夜密会，女方身份引发全网猜测',
    tag: '🔥 独家',
    duration: '03:24',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20evening%20cityscape%20with%20blurred%20silhouettes%20and%20warm%20amber%20streetlights%2C%20paparazzi%20flash%20effect%2C%20cinematic%20moody%20atmosphere%2C%20warm%20orange%20and%20dark%20red%20tones%2C%20editorial%20style%2C%20film%20grain%20texture&width=400&height=225&seq=media-card-01&orientation=landscape',
  },
  {
    title: '热门综艺录制现场突发状况，导演组紧急叫停',
    tag: '🆕 最新',
    duration: '05:18',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20spotlights%20and%20camera%20equipment%2C%20abstract%20motion%20blur%20effect%2C%20warm%20stage%20lighting%2C%20theatrical%20atmosphere%2C%20orange%20and%20crimson%20color%20scheme%2C%20editorial%20photography%20style&width=400&height=225&seq=media-card-02&orientation=landscape',
  },
  {
    title: '知名女星直播带货翻车现场，金句频出笑翻网友',
    tag: '💥 热议',
    duration: '02:47',
    views: '215万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20livestream%20studio%20setup%20with%20ring%20light%20and%20product%20display%2C%20colorful%20vibrant%20background%2C%20warm%20pink%20and%20orange%20glow%2C%20modern%20streaming%20aesthetic%2C%20soft%20bokeh%20effect&width=400&height=225&seq=media-card-03&orientation=landscape',
  },
];

export const appData = {
  title: '随时随地，畅快吃瓜',
  description: '下载51吃瓜网APP，第一时间接收独家爆料推送，不错过任何一条猛料。支持iOS和Android双平台，界面清爽、加载迅速，瓜友社区实时互动。',
  features: ['实时推送', '离线阅读', '社区互动', '独家内容'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20modern%20news%20app%20interface%20with%20warm%20red%20and%20white%20color%20scheme%2C%20clean%20card%20layout%20with%20entertainment%20headlines%2C%20minimal%20UI%20design%2C%20floating%20phone%20on%20light%20cream%20background%2C%20product%20mockup%20style&width=300&height=560&seq=app-mockup&orientation=portrait',
};

export const aboutData = {
  title: '关于51吃瓜网入口',
  intro: '51吃瓜网入口成立于2019年，是国内最具影响力的娱乐圈爆料与黑料聚合平台之一。我们致力于为广大"吃瓜群众"提供最新、最全、最真实的一手爆料资讯，涵盖明星八卦、影视内幕、综艺翻车、直播争议、网红动态等多元内容。平台汇聚了来自全网的热门爆料资源，并通过专业的编辑团队进行甄别与整理，确保每一条信息的时效性与可信度。作为吃瓜爆料第一站，51吃瓜网入口始终秉持"让吃瓜更有料"的理念，持续为瓜友们打造一个有趣、有料、有温度的娱乐资讯社区。',
  highlights: [
    { number: '5年+', label: '持续运营' },
    { number: '12', label: '内容板块' },
    { number: '百万+', label: '日活用户' },
    { number: '7×24', label: '全天更新' },
  ],
};

export const rankingData = [
  { rank: 1, title: '某流量小生被曝与经纪人关系暧昧，工作室紧急发声明', heat: '🔥🔥🔥🔥🔥', tag: '爆' },
  { rank: 2, title: '热门古装剧剧组内部矛盾激化，男女主角疑似不和', heat: '🔥🔥🔥🔥', tag: '热' },
  { rank: 3, title: '知名导演新片选角内幕曝光，潜规则传闻再度发酵', heat: '🔥🔥🔥🔥', tag: '热' },
  { rank: 4, title: '某女星深夜发文疑似暗讽前男友，评论区炸锅', heat: '🔥🔥🔥', tag: '沸' },
  { rank: 5, title: '综艺节目剪辑争议持续升级，嘉宾粉丝集体维权', heat: '🔥🔥🔥', tag: '沸' },
  { rank: 6, title: '网红圈又起波澜，两大头部主播公开互撕', heat: '🔥🔥', tag: '新' },
  { rank: 7, title: '某选秀节目选手背景造假，节目组回应引质疑', heat: '🔥🔥', tag: '新' },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时实时监控全网动态，第一时间推送最新爆料，让您永远快人一步掌握娱乐圈风云变幻。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '真实甄别',
    desc: '专业编辑团队严格把关信息来源，多维度交叉验证，去除虚假传闻，只呈现经得起推敲的真实黑料。',
  },
  {
    icon: 'ri-global-line',
    title: '全网聚合',
    desc: '覆盖微博、抖音、小红书、豆瓣等主流平台的热门话题，一站式浏览全网的吃瓜热点和精彩评论。',
  },
  {
    icon: 'ri-group-line',
    title: '瓜友社区',
    desc: '百万瓜友在线互动，理性讨论、激情吐槽，打造最有温度的吃瓜交流圈，让吃瓜不再孤单。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    desc: '投稿人身份信息严格加密，匿名爆料通道全程保护，让每一位爆料者都能安心分享独家内幕。',
  },
];

export const updatesData = [
  { time: '2小时前', title: '某男团成员机场被拍到与神秘女子同行，粉丝炸开锅', tag: '最新' },
  { time: '4小时前', title: '热门IP改编剧开机仪式，主演阵容出人意料引争议', tag: '热议' },
  { time: '6小时前', title: '知名歌手演唱会假唱实锤？现场音频对比分析曝光', tag: '深扒' },
  { time: '8小时前', title: '某综艺节目嘉宾临时换人，知情人爆料真实原因', tag: '独家' },
  { time: '12小时前', title: '娱乐圈年度慈善晚宴座位安排暗藏玄机', tag: '分析' },
  { time: '16小时前', title: '某女演员社交媒体小号被扒，内容引发网友热议', tag: '吃瓜' },
  { time: '20小时前', title: '热门电视剧大结局争议不断，编剧亲自下场回应', tag: '争议' },
  { time: '1天前', title: '网红孵化机构内部聊天记录泄露，行业潜规则曝光', tag: '爆料' },
];

export const topicsData = [
  { name: '流量小生密会', count: '328万', hot: true },
  { name: '综艺翻车现场', count: '256万', hot: true },
  { name: '明星不和传闻', count: '198万', hot: true },
  { name: '导演选角内幕', count: '175万', hot: false },
  { name: '直播带货争议', count: '152万', hot: false },
  { name: '女星深夜发文', count: '138万', hot: false },
  { name: '剧组矛盾激化', count: '121万', hot: true },
  { name: '男团成员恋情', count: '106万', hot: false },
  { name: '歌手假唱实锤', count: '95万', hot: false },
  { name: '网红互撕大战', count: '82万', hot: false },
  { name: '选秀背景造假', count: '68万', hot: false },
];

export const carouselData = [
  {
    title: '2024娱乐圈年度十大翻车事件全记录',
    desc: '从明星言论翻车到综艺节目争议，盘点今年最具话题性的娱乐圈翻车名场面，每一件都让瓜友直呼过瘾。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20curtain%20falling%20with%20spotlight%20effect%2C%20abstract%20entertainment%20industry%20theme%2C%20warm%20amber%20and%20deep%20red%20gradient%2C%20cinematic%20lighting%2C%20editorial%20illustration%20style%2C%20theatrical%20drama%20atmosphere&width=800&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    title: '深扒娱乐圈那些不为人知的潜规则',
    desc: '从选角到资源分配，从合约条款到幕后交易，揭开娱乐圈光鲜亮丽背后的灰色地带与行业潜规则。',
    tag: '深度爆料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20area%20with%20dramatic%20shadows%20and%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20warm%20spotlight%20breaking%20through%20darkness%2C%20orange%20and%20crimson%20color%20palette%2C%20editorial%20photography%20mood&width=800&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    title: '流量明星商业价值大起底：谁是真顶流',
    desc: '用数据说话，从代言数量、商业报价到粉丝购买力，全方位解析当下流量明星的真实商业价值。',
    tag: '数据分析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20glowing%20charts%20and%20graphs%2C%20modern%20infographic%20style%2C%20warm%20orange%20and%20gold%20color%20scheme%2C%20clean%20geometric%20patterns%2C%20business%20analytics%20aesthetic&width=800&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    title: '综艺节目剪辑术：你看到的全是套路',
    desc: '揭秘综艺节目后期剪辑的惯用套路，从恶意剪辑到剧本设计，教你一眼识破节目组的"神剪辑"。',
    tag: '行业揭秘',
    image: 'https://readdy.ai/api/search-image?query=Film%20editing%20suite%20with%20multiple%20monitors%20displaying%20colorful%20timeline%20tracks%2C%20creative%20workspace%20atmosphere%2C%20warm%20studio%20lighting%2C%20orange%20and%20amber%20tones%2C%20modern%20post-production%20aesthetic&width=800&height=400&seq=carousel-04&orientation=landscape',
  },
];

export const contactData = {
  title: '投稿爆料',
  subtitle: '你有猛料，我有平台',
  description: '欢迎广大瓜友踊跃投稿！如果您掌握独家内幕、一手爆料或娱乐圈最新动态，51吃瓜网入口为您提供最安全的匿名爆料通道。我们郑重承诺：严格保护每一位爆料人的身份信息安全，绝不泄露任何投稿来源。',
  tips: ['信息加密传输', '身份严格保密', '专业团队核实', '快速响应处理'],
  email: 'tips@51chigua.com',
};

export const indexData = [
  { title: '明星八卦', count: 1286, icon: 'ri-star-line', desc: '最新明星动态与私生活揭秘' },
  { title: '综艺翻车', count: 856, icon: 'ri-tv-line', desc: '综艺节目争议与幕后故事' },
  { title: '影视内幕', count: 732, icon: 'ri-film-line', desc: '电影电视剧行业深度爆料' },
  { title: '直播争议', count: 645, icon: 'ri-live-line', desc: '直播平台热点话题追踪' },
  { title: '网红动态', count: 521, icon: 'ri-user-smile-line', desc: '网红圈最新动向与八卦' },
  { title: '选秀揭秘', count: 398, icon: 'ri-mic-line', desc: '选秀节目黑幕与选手爆料' },
  { title: '音乐圈料', count: 367, icon: 'ri-music-line', desc: '音乐圈内幕与歌手八卦' },
];

export const cardsData = [
  {
    title: '某知名导演新片片场亲密举动被拍，与女主角关系引猜测',
    excerpt: '近日有网友爆料，某知名导演在片场对女主角格外照顾，两人互动频繁且亲密，引发剧组内部议论纷纷……',
    date: '2024-07-29',
    tag: '独家爆料',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20warm%20cinematic%20lighting%2C%20abstract%20composition%2C%20soft%20orange%20and%20gold%20tones%2C%20editorial%20mood&width=400&height=250&seq=card-01&orientation=landscape',
  },
  {
    title: '热门综艺节目组内部不和曝光，总导演与制片人矛盾升级',
    excerpt: '据知情人士透露，某热门综艺的总导演与制片人在节目方向上存在严重分歧，多次在会议中激烈争吵……',
    date: '2024-07-28',
    tag: '深度深扒',
    image: 'https://readdy.ai/api/search-image?query=TV%20production%20meeting%20room%20with%20dramatic%20shadows%2C%20tense%20atmosphere%2C%20warm%20overhead%20lighting%2C%20orange%20and%20dark%20amber%20color%20scheme%2C%20editorial%20photography&width=400&height=250&seq=card-02&orientation=landscape',
  },
  {
    title: '女星直播时意外走光，经纪人紧急切断画面引发更大风波',
    excerpt: '一场看似平常的带货直播却因为意外走光事件引发全网热议，经纪人的应急处理方式反而让事件持续发酵……',
    date: '2024-07-27',
    tag: '热点追踪',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20livestream%20studio%20with%20ring%20light%20glare%2C%20dramatic%20moment%2C%20warm%20pink%20and%20orange%20glow%2C%20modern%20streaming%20setup%2C%20editorial%20style&width=400&height=250&seq=card-03&orientation=landscape',
  },
  {
    title: '流量小生被前经纪人爆料私生活混乱，粉丝集体脱粉',
    excerpt: '一位自称是某流量小生前经纪人的网友在社交平台发布长文，详细描述了该艺人的私生活细节，引发轩然大波……',
    date: '2024-07-26',
    tag: '劲爆猛料',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20feed%20with%20dramatic%20red%20notifications%2C%20abstract%20digital%20controversy%20theme%2C%20warm%20orange%20and%20crimson%20tones%2C%20modern%20smartphone%20screen%20mockup&width=400&height=250&seq=card-04&orientation=landscape',
  },
  {
    title: '某剧组拍摄期间发生安全事故，演员受伤引发粉丝维权',
    excerpt: '剧组在拍摄高难度动作戏时发生意外，一名主要演员受伤送医，粉丝纷纷质疑剧组的安保措施是否到位……',
    date: '2024-07-25',
    tag: '突发事件',
    image: 'https://readdy.ai/api/search-image?query=Movie%20action%20scene%20setup%20with%20safety%20equipment%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20red%20alert%20tones%2C%20cinematic%20production%20atmosphere%2C%20editorial%20style&width=400&height=250&seq=card-05&orientation=landscape',
  },
  {
    title: '知名歌手新专辑涉嫌抄袭，原作者发律师函要求下架',
    excerpt: '有网友对比发现某知名歌手新专辑中的主打歌与国外一位独立音乐人的作品高度相似，已引发版权争议……',
    date: '2024-07-24',
    tag: '版权争议',
    image: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20sheet%20music%20and%20headphones%2C%20dramatic%20contrast%20lighting%2C%20warm%20golden%20and%20orange%20tones%2C%20creative%20workspace%20atmosphere%2C%20editorial%20photography&width=400&height=250&seq=card-06&orientation=landscape',
  },
  {
    title: '某选秀节目导师被曝收选手贿赂，节目组启动调查',
    excerpt: '一封匿名举报信直指某选秀节目导师存在收受选手好处的不当行为，节目组已公开表示将严肃处理此事……',
    date: '2024-07-23',
    tag: '重磅调查',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlight%20and%20dramatic%20shadows%2C%20investigation%20theme%2C%20warm%20amber%20and%20deep%20red%20contrast%2C%20theatrical%20atmosphere%2C%20editorial%20style&width=400&height=250&seq=card-07&orientation=landscape',
  },
];

export const commentsData = [
  {
    name: '吃瓜不嫌事大',
    avatar: '🍉',
    time: '3小时前',
    content: '这瓜保熟吗？不过看这阵势应该是真的，圈内人都知道这些事，只是没人敢说而已。51吃瓜网真敢爆，佩服佩服！',
    likes: 2836,
  },
  {
    name: '理性吃瓜群众',
    avatar: '🧐',
    time: '5小时前',
    content: '坐等实锤，现在各家粉丝都在洗，建议等工作室正式回应后再下结论。不过51吃瓜网的爆料一向靠谱，这次大概率也是真的。',
    likes: 1852,
  },
  {
    name: '娱乐圈观察员',
    avatar: '🎬',
    time: '8小时前',
    content: '作为在这个行业摸爬滚打多年的老人，我只能说这篇爆料里面90%的内容都是真实的。有些事情比爆出来的还要夸张，只是不方便说。',
    likes: 3421,
  },
  {
    name: '深夜吃瓜人',
    avatar: '🦉',
    time: '12小时前',
    content: '凌晨三点还在刷51吃瓜网，这你受得了吗？但是每一条都好精彩啊根本停不下来！希望明天起来能看到更多后续爆料。',
    likes: 1567,
  },
];

export const faqData = [
  {
    question: '51吃瓜网的爆料内容可靠吗？',
    answer: '我们拥有专业的编辑团队，对每一条爆料信息都会进行多维度交叉验证。虽然娱乐圈消息瞬息万变，但我们承诺只发布经过核实的内容。对于暂时无法完全确认的信息，我们会标注"待核实"标签，让瓜友们自行判断。',
  },
  {
    question: '如何在51吃瓜网投稿爆料？',
    answer: '您可以通过页面底部的"投稿爆料"入口提交您的独家信息。我们支持文字、图片和视频等多种形式的投稿，并且采用端到端加密技术保护您的身份信息安全。编辑团队收到投稿后会尽快核实并发布。',
  },
  {
    question: '51吃瓜网为什么叫"吃瓜"？',
    answer: '"吃瓜"源自网络流行语"吃瓜群众"，意指旁观者边吃西瓜边看热闹的状态。51吃瓜网取此名，寓意我们为广大网友提供最丰富、最新鲜的娱乐圈八卦"瓜"，让大家在繁忙生活中轻松"吃瓜"解压。',
  },
  {
    question: '你们和其他娱乐资讯平台有什么不同？',
    answer: '不同于传统娱乐媒体，51吃瓜网更聚焦于"爆料"和"黑料"领域，内容更加大胆直接。我们不做表面功夫的娱乐新闻，而是深入挖掘娱乐圈的幕后故事和不为人知的内幕。同时，我们坚持保护爆料人隐私，这在行业内是独一无二的。',
  },
  {
    question: '遇到侵权内容怎么处理？',
    answer: '我们严格遵守相关法律法规。如果您认为平台上的内容侵犯了您的合法权益，可以通过页面底部的联系方式或发送邮件至我们的官方邮箱提交侵权投诉。我们会在收到有效通知后的24小时内进行审核处理。',
  },
  {
    question: '51吃瓜网有APP吗？如何下载？',
    answer: '有的！51吃瓜网APP已上架各大应用商店，支持iOS和Android双平台。您可以在App Store或各大安卓应用市场搜索"51吃瓜"下载。APP支持实时推送、离线阅读和社区互动功能，让您随时随地畅快吃瓜。',
  },
];

export const footerData = {
  intro: '51吃瓜网入口——全网领先的娱乐圈黑料爆料聚合平台。覆盖明星八卦、影视内幕、综艺争议、直播翻车等热门领域，为亿万吃瓜群众提供最新、最全、最真实的一手爆料资讯。吃瓜爆料第一站，认准51吃瓜网。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '吃瓜现场', href: '#media' },
        { label: '热度榜单', href: '#ranking' },
        { label: '焦点专题', href: '#carousel' },
        { label: '吃瓜精选', href: '#cards' },
        { label: '吃瓜索引', href: '#index' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '投稿爆料', href: '#contact' },
        { label: '隐私政策', href: '#faq' },
        { label: '侵权投诉', href: '#faq' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
      isPartner: true,
    },
  ],
};